import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const templateEditorPlacePreviewStyles: IStyles = {
    preview: {
        position: 'absolute',
        border: `1.5px solid ${color.blue}`,
        background: `${color.blue}1f`,
        boxShadow: `inset 0 0 0 1px ${color.bgWhitePrimary}73`,
        pointerEvents: 'none',
        boxSizing: 'border-box',
        zIndex: 20,
        overflow: 'hidden',
    },
    shapePreview: {
        position: 'absolute',
        pointerEvents: 'none',
        boxSizing: 'border-box',
        zIndex: 20,
        overflow: 'visible',
    },
    shapeBody: {
        width: '100%',
        height: '100%',
        display: 'block',
        pointerEvents: 'none',
    },
    grid: {
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
    },
    lineH: {
        position: 'absolute',
        left: 0,
        right: 0,
        height: 1,
        background: `${color.blue}73`,
        pointerEvents: 'none',
    },
    lineV: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: 1,
        background: `${color.blue}73`,
        pointerEvents: 'none',
    },
    badge: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        padding: '4px 8px',
        borderRadius: 6,
        background: 'rgba(26, 26, 35, 0.82)',
        color: color.bgWhitePrimary,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.02em',
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        zIndex: 2,
        boxShadow: '0 2px 8px rgba(26, 26, 35, 0.25)',
    },
}

addStyles(templateEditorPlacePreviewStyles)
export default templateEditorPlacePreviewStyles
